import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { OnAdvisorClick } from "../../handlers";
import { RadioGroup } from "@headlessui/react";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IAdvisorProps } from "../types";
import RadioComponentWithSelectionBox from "@portal/components/atoms/v2/radioComponentWithSelectionBox";

export const AdvisorOptions = ({ isDefaultLanguage, advisorCarriedOut, setAdvisorCarriedOut, dispatch }: IAdvisorProps) => {
  const [advisor, setAdvisor] = useState(advisorCarriedOut ? 1 : 0);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_16_A, texts.PAGE_16_B];

  const handleChange = (i: number) => {
    setAdvisor(i);
    OnAdvisorClick(i, setAdvisorCarriedOut, dispatch);
  };

  return (
    <div className="flex flex-col">
      <RadioGroup value={advisor} onChange={handleChange} className="space-y-3">
        {options.map((text, i) => (
          <RadioComponentWithSelectionBox key={i} value={i} id={i.toString()}>
            <div className="flex flex-col p-2">
              <Typography>{text}</Typography>
            </div>
          </RadioComponentWithSelectionBox>
        ))}
      </RadioGroup>
    </div>
  );
};
